// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cmp-footer__nav-desktop{background-color:#fff;margin-bottom:40px;display:none}@media (min-width:1024px){.cmp-footer__nav-desktop{display:block}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
